/**
 * @Description:
 * @Author: fangzheng
 * @Date: 2020/8/3
 */
export default {
  organization: {
    organization: '组织',
    organizationDetails: '组织详情',
    essentialInformation: '基本信息',
    superiorOrganization: '上级组织',
    organizationType: '组织类型',
    organizationNumber: '组织编号',
    organizationName: '组织名称',
    tell: '联系方式',
    address: '详细地址',
    remarks: '备注',
    staff: '组织人员',
    employeeNumber: '员工编号',
    employeeName: '员工姓名',
    mobileNumber: '手机号码',
    addAssociatedEmployee: '添加关联员工',
    save: '保存',
    state: '状态',
    remove: '移除',
    corporateInformation:'法人信息',
    socialCreditCode:'社会信用代码',
    legalPerson:'法人姓名',
    businessLicense:'营业执照副本',
    originalCard :'法人身份证(正)',
    counterCard :'法人身份证(反)',
    company:'公司',
    department:'部门',
    addRoot:'新增根节点',
    rootName:'根节点名称',
    rootCode :'根节点编号',
    relatedEmployee: '已关联员工',
    associated:'已关联',
    'code-0001':'请输入组织编号',
    'code-0002':'只能输入数字或字母',
    'code-0003':'请输入社会信用代码',
    'code-0004':'新增组织成功',
    'code-0005':'编辑组织成功',
    'code-0006':'新增根节点成功',
    'code-0007':'删除组织成功',
    'code-0008':'已经在第一位',
    'code-0009':'已经在最后一位',
    'code-0010':'请选中一个组织',
    'code-0011':'至少选中一项',
    'code-0012':'添加关联员工成功',
  }
};


// WEBPACK FOOTER //
// ./src/config/langs/tc/organization.js